"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.19.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequisitionSpecialTypeToJSON = exports.RequisitionSpecialTypeFromJSONTyped = exports.RequisitionSpecialTypeFromJSON = exports.RequisitionSpecialType = void 0;
/**
 * Special type tags
 * @export
 */
exports.RequisitionSpecialType = {
    FetalSample: 'fetal_sample',
    FvtExternal: 'fvt_external',
    FvtExternalWithPositiveControl: 'fvt_external_with_positive_control',
    FvtInternal: 'fvt_internal',
    FvtOnly: 'fvt_only',
    FvtWithAdditionalGenes: 'fvt_with_additional_genes',
    FvtWithFullGene: 'fvt_with_full_gene',
    HematologicMalignancy: 'hematologic_malignancy',
    Other: 'other',
    PositiveControl: 'positive_control',
    Reflex: 'reflex',
    TestOfRelatedSamples: 'test_of_related_samples',
    TestOfRelatedSamplesNeedsJointAnalysis: 'test_of_related_samples_needs_joint_analysis',
    Tp53VariantProgram: 'tp53_variant_program',
    VusRecommended: 'vus_recommended',
    VusResolution: 'vus_resolution'
};
function RequisitionSpecialTypeFromJSON(json) {
    return RequisitionSpecialTypeFromJSONTyped(json, false);
}
exports.RequisitionSpecialTypeFromJSON = RequisitionSpecialTypeFromJSON;
function RequisitionSpecialTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.RequisitionSpecialTypeFromJSONTyped = RequisitionSpecialTypeFromJSONTyped;
function RequisitionSpecialTypeToJSON(value) {
    return value;
}
exports.RequisitionSpecialTypeToJSON = RequisitionSpecialTypeToJSON;
